// trap tabbing within element/modal
export default class TabTrap {
    constructor(selector, initialFocus = null) {
        this.selector = selector;
        this.focusableElements = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
        this.ele = document.querySelector(this.selector);
        this.firstFocusableElement = this.ele.querySelectorAll(this.focusableElements)[0];
        this.focusableContent = this.ele.querySelectorAll(this.focusableElements);
        this.focusableContent = Array.from(this.focusableContent);
        this.lastFocusableElement = this.focusableContent[this.focusableContent.length - 1];
        this.initialFocus = initialFocus;
        this.additionalContent = [];
        this.lastFocusedElement = null;
    }
    handleKeyDown = (e) => {
        let isTabPressed = e.key === 'Tab' || e.keyCode === 9;
        if (!isTabPressed) {
            return;
        }
        if (e.shiftKey) {
            if (document.activeElement === this.firstFocusableElement) {
                this.lastFocusableElement.focus();
                e.preventDefault();
            }
        } else {
            if (document.activeElement === this.lastFocusableElement) {
                this.firstFocusableElement.focus();
                e.preventDefault();
            }
        }
    }
    update = (focusableElements = null) => {
        if (focusableElements) {
            this.focusableElements = focusableElements;
        }
        this.firstFocusableElement = this.ele.querySelectorAll(this.focusableElements)[0];
        this.focusableContent = this.ele.querySelectorAll(this.focusableElements);
        this.focusableContent = Array.from(this.focusableContent);
        this.additionalContent.forEach(element => {
            this.focusableContent.push(element);
        })
        this.lastFocusableElement = this.focusableContent[this.focusableContent.length - 1];
    }
    addElement = (element) => {
        this.additionalContent.push(element);
        this.update();
    }
    incrementTabIndexes = () => {
        this.focusableContent.forEach((element, i) => {
            element.setAttribute('tabindex', i + 1);
        })
    }
    removeTabIndexes = () => {
        this.focusableContent.forEach((element, i) => {
            // element.removeAttribute('tabindex');
            element.setAttribute('tabindex', '-1');
        })
    }

    on = () => {
        this.lastFocusedElement = document.activeElement;
        this.incrementTabIndexes();
        document.addEventListener('keydown', this.handleKeyDown);
        
        if (this.initialFocus) {
            this.initialFocus.focus();
        } else {
            this.firstFocusableElement.focus();
        }
    }

    off = () => {
        this.removeTabIndexes();
        document.removeEventListener('keydown', this.handleKeyDown);

        if (this.lastFocusedElement) {
            this.lastFocusedElement.focus();
            this.lastFocusedElement = null;
        }
    }
}